export function createCursorController(cursor) {
  if (!cursor) {
    return {
      update() {},
      show() {},
      hide() {},
      open() {},
      close() {},
      destroy() {},
    };
  }

  let cursorX = 0;
  let cursorY = 0;
  let targetX = 0;
  let targetY = 0;
  let rafId = null;
  let isInitialized = false;

  let halfWidth = 12;
  let halfHeight = 12;

  const measureBounds = () => {
    const bounds = cursor.getBoundingClientRect();
    if (bounds.width > 0) {
      halfWidth = bounds.width / 2;
      halfHeight = bounds.height / 2;
    }
  };

  measureBounds();

  const animate = () => {
    cursorX += (targetX - cursorX) * 0.18;
    cursorY += (targetY - cursorY) * 0.18;
    cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
    rafId = window.requestAnimationFrame(animate);
  };

  const update = (event) => {
    targetX = event.clientX - halfWidth;
    targetY = event.clientY - halfHeight;

    if (!isInitialized) {
      cursorX = targetX;
      cursorY = targetY;
      cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      isInitialized = true;
    }

    if (rafId === null) {
      rafId = window.requestAnimationFrame(animate);
    }
  };

  const show = () => cursor.classList.add("is-visible");
  const hide = () => cursor.classList.remove("is-visible");
  const open = () => cursor.classList.add("is-open");
  const close = () => cursor.classList.remove("is-open");

  const destroy = () => {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  return { update, show, hide, open, close, destroy };
}
